import { useContext } from 'react';
import { MainContext } from 'context';
import { emitters } from 'config';
import { styled } from 'themes';

const Container = styled('div', {
  display: 'flex',
  position: 'relative',
  width: '100%',
  maxWidth: 88,
  height: 'auto',
  marginX: 30,
  marginLeft: 0,

  '&:focus': {
    boxShadow: '0px 0px 8px rgba(2, 72, 20, 0.84)',
    borderRadius: 9,
  },

  '@media (max-width: 768px)': {
    marginX: 0,
    marginBottom: 16,
  },
});

const Img = styled('img', {
  height: '100%',
  width: '100%',
});

export default function Logo() {
  const { state } = useContext(MainContext);

  return (
    <Container>
      <Img src={`${emitters[state.emissor].logo}`} alt={state.emissor} />
    </Container>
  );
}
